<template>
    <div class="voicemod-bits-twitch-app">
        <router-view></router-view>
    </div>
</template>

<script>
import { i18n } from '@/i18n-setup.js';
import { messages } from './lang/messages.js';
import { mapState, mapActions } from 'vuex';

export default {
    computed: {
        ...mapState({
            globalStore: state => state.global,
        }),
    },

    mounted() {
        this.setUpLocale();

        this.$twitch.onAuthorized(async (auth) => {
            this.axn_loadTwitchInfo(auth);
        });
    },

    methods: {
        ...mapActions({
            axn_loadTwitchInfo: 'global/axn_loadTwitchInfo',
        }),

        setUpLocale() {
            const locales = Object.keys(messages);

            i18n.locale = locales.includes(this.getTwitchLanguage()) ? this.getTwitchLanguage() : 'en';
        },

        getTwitchLanguage() {
            const params = new URLSearchParams(window.location.search);
            const paramsLanguage = params.get('language');
            const language = paramsLanguage.includes('-') ? paramsLanguage.substring(0, paramsLanguage.indexOf('-')) : paramsLanguage;

            return language;
        },
    },
};
</script>

<style lang="scss">
    @import '../node_modules/voicemod-modules/style/partials/global.scss';
    @import '../node_modules/voicemod-modules/style/partials/helpers.scss';
</style>
